export const cssClasses = (_classes: string[]): string => _classes.join(' ');
